import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { useCallback, useState } from 'react';
import { generateUniqueId } from 'seagull/utils/generateUniqueId';
import { useIoContext, useOverlayContext, useStoreActions } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { PDF_MAX_SIZE_BYTES } from '~/models/custom-page/model';
export function useUploadCustomPagePdf(param) {
    let { onSuccess, fileSizeErrorTestId, uploadErrorTestId } = param;
    const { t } = useLocaleKeys();
    const { api } = useStoreActions();
    const { browser: { uploadFileToCloudStorage } } = useIoContext();
    const { showErrorToast } = useOverlayContext();
    const [isUploading, setIsUploading] = useState(false);
    const handleFileSelected = useCallback(async (file)=>{
        if (file.size > PDF_MAX_SIZE_BYTES) {
            showErrorToast(t.customPages.pdfUpload.fileSizeError(), fileSizeErrorTestId);
            return;
        }
        setIsUploading(true);
        try {
            var _uploadEntry_headers;
            const pdfName = generateUniqueId('file');
            const { urls } = await api.business.getUploadUrls([
                {
                    id: pdfName,
                    displayName: file.name
                }
            ]);
            const uploadEntry = urls[0];
            if (uploadEntry == null) {
                showErrorToast(t.customPages.pdfUpload.uploadError(), uploadErrorTestId);
                return;
            }
            await uploadFileToCloudStorage(uploadEntry.url, file, _object_spread({
                'content-type': 'application/pdf'
            }, (_uploadEntry_headers = uploadEntry.headers) !== null && _uploadEntry_headers !== void 0 ? _uploadEntry_headers : {}));
            onSuccess({
                pdfName,
                pdfFileName: file.name,
                fileSizeBytes: file.size
            });
        } catch (unused) {
            showErrorToast(t.customPages.pdfUpload.uploadError(), uploadErrorTestId);
        } finally{
            setIsUploading(false);
        }
    }, [
        api.business,
        fileSizeErrorTestId,
        onSuccess,
        showErrorToast,
        t,
        uploadErrorTestId,
        uploadFileToCloudStorage
    ]);
    return {
        handleFileSelected,
        isUploading
    };
}
